module.exports = __webpack_public_path__ + "img/sign-4.360e2f12.jpg";